import axios from 'axios';

const getSingleProductApi = async (id, token) => {
  try {
    const res = await axios.get(`/Product/single?id=${id}`, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'applications/json',
        Authorization: 'Bearer ' + token,
        lang: 'ar'
      }
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export default getSingleProductApi;
